<div id="TPDAsPage">
  <div class="toolbar">
    <div class="left">
      <app-search-input
        [placeholder]="'tpda.name' | translate"
        [searchValue]="globalSearchValue"
        (searchChange)="updateSearch($event)"
      ></app-search-input>
    </div>

    <button mat-icon-button (click)="openHelp()">
      <mat-icon style="font-size: 30px" matTooltip="{{ 'btn.help' | translate }}">help_outline</mat-icon>
    </button>
    <div class="spacer"></div>
    <!--<button mat-stroked-button (click)="activateCheckBox()"
            matTooltip="{{ 'page.patientlist.multiSelect' | translate }}">
            <mat-icon>check_box</mat-icon>
        </button>-->
    <button mat-stroked-button (click)="clearFilter()" matTooltip="{{ 'itemFilter.clearAll' | translate }}" aria-label="Clear all filters">
      <img class="custom-icon" src="assets/images/custom-icon/clear-filter.png" />
    </button>
    <div class="right">
      <app-item-selector
        [items]="availableColumnItems"
        (changed)="availableColumnChanged()"
        [translate]="true"
        matTooltip="{{ 'page.patientlist.columnsSelect' | translate }}"
      >
      </app-item-selector>
    </div>
  </div>

  <app-filters-display [filters]="filters" (removeFilter)="applyFilter($event)"> </app-filters-display>
  <mat-card class="mat-elevation-z0 pt-0">
    <mat-table class="mat-elevation-z1" [dataSource]="dataSource" matSort matSortActive="name" matSortDirection="asc">
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "tpda.name" | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.name }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="nbParticipants">
        <mat-header-cell *matHeaderCellDef>
          {{ "tpda.nbParticipants" | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let row"
          >{{ row.nbParticipants }}

          <button
            mat-icon-button
            matTooltip="{{ 'tpda.seeParticipants' | translate }}"
            aria-label="icon button with an loupe icon"
            *ngIf="('dashboard/TPDA/participant' | isAuthorized | async) === true"
            (click)="showParticipants(row)"
          >
            <mat-icon class="custom-icon-small sub-align">search</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="nbResults">
        <mat-header-cell *matHeaderCellDef>
          {{ "tpda.nbResults" | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let row"
          >{{ row.nbResults }}
          <button
            mat-icon-button
            matTooltip="{{ 'tpda.seeQuestionnaireResponses' | translate }}"
            *ngIf="('dashboard/TPDA/questionnaireResponse' | isAuthorized | async) === true"
            aria-label="icon button with an loupe icon"
            (click)="showQRs(row)"
          >
            <mat-icon class="custom-icon-small sub-align">search</mat-icon>
          </button></mat-cell
        >
      </ng-container>

      <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef>
          {{ "table.action" | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <button
            mat-icon-button
            matTooltip="{{ 'tpda.visitTPDA' | translate }}"
            aria-label="icon button with an external link icon"
            (click)="goToLink(row)"
          >
            <mat-icon class="custom-icon-small sub-align">link</mat-icon>
          </button>
          <button
            mat-icon-button
            matTooltip="{{ 'tpda.sendMailInvites' | translate }}"
            aria-label="icon button with an mail icon"
            *ngIf="('dashboard/TPDA/invite' | isAuthorized : 'POST' | async) === true"
            (click)="sendInvites(row)"
          >
            <mat-icon class="custom-icon-small sub-align">mail_outline</mat-icon>
          </button>
          <button
            mat-icon-button
            [disabled]="isDownloading"
            matTooltip="{{ 'tpda.downloadConsentForms' | translate }}"
            aria-label="icon button with an download icon"
            *ngIf="('dashboard/TPDA/consentform' | isAuthorized | async) === true"
            (click)="downloadConsents(row)"
          >
            <mat-icon fontSet="fas" fontIcon="fa-file-download"></mat-icon>
          </button>
          <button
            mat-icon-button
            [disabled]="isDownloading"
            matTooltip="{{ 'tpda.downloadQRs' | translate }}"
            aria-label="icon button with an download icon"
            *ngIf="('dashboard/TPDA/QRsPDF' | isAuthorized | async) === true"
            (click)="downloadQRs(row)"
          >
            <mat-icon fontSet="fas" fontIcon="fa-file-archive"></mat-icon>
          </button>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
    <div class="loading" *ngIf="loading">
      <div class="spinner-container">
        <mat-spinner></mat-spinner>
      </div>
      {{ "common.loading" | translate }}
    </div>
    <mat-paginator
      class="mat-elevation-z1"
      pageIndex="0"
      [length]="totalCount"
      [pageSize]="currentPageSize"
      [pageSizeOptions]="[10, 25, 50, 100]"
    ></mat-paginator>
  </mat-card>
</div>
